import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from '@els/els-react--select';
import HeaderInfoIcon from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoIcon';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import DialogRow from '@Pages/RetroSynthesis/ExportRoute/components/DialogRow';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';

import './ExportFormats.scss';

function ExportFormats({ options, tooltipText, onSelectFormat, value }) {
  return (
    <DialogRow className="export-formats" label="Choose a format:">
      <div className="rx-flex-row-container">
        <SingleSelect
          label="Export Format"
          shouldHideLabel
          placeholderText="Select..."
          options={options}
          optionsFlyoutProps={{ noInternalPadding: true, theme: 'default', placement: 'bottom', pointer: true, pointerType: 'primary' }}
          value={value}
          onSelect={(option) => onSelectFormat(option)}
          required
        />
        <div className="export-formats__tooltip">
          <HeaderInfoIcon tooltipId="export-formats-tooltip" />
          <HeaderInfoTooltip id="export-formats-tooltip" rightAlign>
            <div className="rs-tooltip-big__content tooltip-content">
              <InnerHTML
                html={tooltipText}
                tag="span"
                mode="escape"
                allowedTags={allowedTagsDefault.concat('a')}
                allowedAttributes={['href', 'target']}
              />
            </div>
          </HeaderInfoTooltip>
        </div>
      </div>
    </DialogRow>
  );
}

export default ExportFormats;

ExportFormats.propTypes = {
  onSelectFormat: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.any,
  tooltipText: PropTypes.string,
};
